'use client'

import type { TrackerCopy } from '@/lib/santa-tracker'

/**
 * «Ahora mismo en el Polo Norte»: una frase que cambia cada tres horas y da la
 * sensación de que al otro lado hay alguien trabajando. La elige
 * `resolveWorkshopActivity` de forma determinista, y de madrugada manda la
 * lista nocturna.
 */
export function TrackerWorkshopCard({ copy, activity }: { copy: TrackerCopy; activity: string }) {
  return (
    <section
      aria-labelledby="tracker-workshop-heading"
      className="rounded-3xl border border-white/10 bg-white/5 p-6 shadow-lg md:p-8"
    >
      <h2
        id="tracker-workshop-heading"
        className="font-christmas text-2xl font-semibold md:text-3xl"
      >
        {copy.workshop.heading}
      </h2>
      <p aria-live="polite" className="mt-3 text-lg text-white/85">
        {activity}
      </p>
    </section>
  )
}
